export default "__VITE_ASSET__DV49BZMm__"